import { useEffect, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Container from "react-bootstrap/esm/Container";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-typeahead/css/Typeahead.min.css";
import "./App.css";

import AuthService from "./services/AuthService";
import ConfigService from "./services/ConfigService";

import EventBus from "./utils/EventBus";

import Login from "./views/Login";
import TopNavBar from "./components/navbars/TopNavBar";
import Dashboard from "./views/Dashboard";
import Reports from "./views/Reports";
import ReportsProjects from "./views/ReportsProjects";
import Customers from "./views/Customers";
import Entities from "./views/Entities";
import Partners from "./views/Partners";
import Projects from "./views/Projects";
import Providers from "./views/Providers";
import Users from "./views/Users";
import Invoices from "./views/Invoices";
import Incomes from "./views/Incomes";
import ExpensesProjects from "./views/ExpensesProjects";
import PaymentsPartners from "./views/PaymentsPartners";
import Expenses from "./views/Expenses";
import Payrolls from "./views/Payrolls";
import Footer from "./components/navbars/Footer";
import MyProfile from "./views/MyProfile";
import Config from "./views/Config";
import { useNavigate } from "react-router-dom";

const App = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false); // Control web refresh
  const navigate = useNavigate();
  const setTitle = async () => {
    const config = await ConfigService.getConfigNoAuth();
    document.title = config.data.title;
  };

  const logIn = async () => {
    const user = await AuthService.getCurrentUser();
    setCurrentUser(user);
    setAuthChecked(true);
  };

  const logOut = () => {
    AuthService.removeCurrentUser();
    setCurrentUser(null);
    setAuthChecked(true);
    navigate("/login");
  };

  useEffect(() => {
    setTitle();

    // Llamamos a logIn en cuanto se monta el componente
    logIn();

    // Configuración de escucha de eventos
    const handleLogin = () => {
      logIn(); // Rehacer el login si el evento "login" se dispara
    };

    const handleLogout = () => {
      logOut();
    };

    EventBus.on("login", handleLogin); // Suscribir al evento "login"
    EventBus.on("logout", handleLogout); // Suscribir al evento "logout"

    // Cleanup de suscripciones al desmontar el componente
    return () => {
      EventBus.remove("login", handleLogin); // Eliminar la suscripción al evento "login"
      EventBus.remove("logout", handleLogout); // Eliminar la suscripción al evento "logout"
    };
  }, []); // Pasamos un array vacío para ejecutar solo cuando el componente se monta y desmonta


  if (!authChecked) {
    return null;
  }

  return (
    <Container fluid className="p-0">
        {currentUser && <TopNavBar currentUser={currentUser} />}
        <Routes>
          {!currentUser ? (
            <>
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          ) : (
            <>
              <Route path="/profile" element={<MyProfile />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/projectsReports" element={<ReportsProjects />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/entities" element={<Entities />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/providers" element={<Providers />} />
              <Route path="/users" element={<Users />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/incomes" element={<Incomes />} />
              <Route path="/expenses" element={<Expenses />} />
              <Route path="/expensesProjects" element={<ExpensesProjects />} />
              <Route path="/paymentsPartners" element={<PaymentsPartners />} />
              <Route path="/payrolls" element={<Payrolls />} />
              <Route path="/config" element={<Config />} />
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </>
          )}
        </Routes>
        <Footer />
    </Container>
  );
};

export default App;
